import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatCardProps {
  title: string;
  value: string;
  change: string;
  changeType: 'positive' | 'negative' | 'neutral';
  icon: LucideIcon;
  gradient?: boolean;
  onClick?: () => void;
}

export function StatCard({ 
  title, 
  value, 
  change, 
  changeType, 
  icon: Icon,
  gradient = false,
  onClick 
}: StatCardProps) {
  const changeColor = {
    positive: 'text-success',
    negative: 'text-destructive',
    neutral: 'text-muted-foreground'
  }[changeType];

  const changeSymbol = {
    positive: '+',
    negative: '',
    neutral: ''
  }[changeType];

  return (
    <Card 
      className={cn(
        "relative overflow-hidden transition-all duration-300 hover:shadow-card hover:-translate-y-1 bg-cream-80",
        gradient && "bg-gradient-primary text-primary-foreground",
        onClick && "cursor-pointer"
      )}
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <p className={cn(
              "text-12 font-medium",
              gradient ? "text-primary-foreground/80" : "text-muted-foreground"
            )}>
              {title}
            </p>
            <p className="text-16 font-bold">
              {value}
            </p>
            <p className={cn(
              "text-12 flex items-center",
              gradient ? "text-primary-foreground/70" : changeColor
            )}>
              {changeSymbol}{change}
            </p>
          </div>
          <div className={cn(
            "p-3 rounded-lg",
            gradient 
              ? "bg-white/10" 
              : "bg-cream-70"
          )}>
            <Icon className={cn(
              "h-6 w-6",
              gradient ? "text-primary-foreground" : "text-primary"
            )} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}